<edu-card>
  <img alt="alternative" [src]="img" />
  <p class="content-text">{{ this.content }}</p>
  <div class="title-row">
    <h4 class="title">{{ title }}</h4>
    <mat-icon svgIcon="arrow-right" class="icon"></mat-icon>
  </div>
</edu-card>
